<div *ngIf="isInDropdown && loadingTenants">
    <hc-progress-spinner [diameter]="48" [color]="'blue'"></hc-progress-spinner>
</div>
<div [class.tenant-switcher-large]="!isInDropdown" *ngIf="!(isInDropdown && loadingTenants)">
    <div class="tenant-switcher-search-container">
        <label>Select a tenant:</label>
        <hc-search-bar
            #tenantSearch
            placeholder="Search..."
            [autoSearch]="true"
            (triggerSearch)="search($event)"
            (keydown)="onSearchKeydown($event)"
        ></hc-search-bar>
    </div>
    <div class="tenant-switcher-list-container">
        <cdp-grid-states
            nameSingular="tenant"
            namePlural="tenants"
            [loading]="loadingTenants"
            [loadFailed]="loadingTenantsFailed"
            [searchValue]="tenantSearch.value"
            [dataSource]="tenantsDataSource"
            [allowAddNew]="false"
            (clearSearch)="tenantSearch.clear()"
            (refresh)="loadTenantList(true)"
        >
        </cdp-grid-states>

        @if (favTenantsDataSource.filteredData.length > 0) {
            <h4 class="tenant-switcher-section-header">Favorites</h4>
            @for (tenant of favTenantsDataSource.filteredData; track tenant.tenantId) {
                <ng-container *ngTemplateOutlet="tenantRowTemplate; context: { tenant: tenant }"></ng-container>
            }
            <h4 class="tenant-switcher-section-header">All</h4>
        }

        @for (tenant of tenantsDataSource.filteredData; track tenant.tenantId) {
            <ng-container *ngTemplateOutlet="tenantRowTemplate; context: { tenant: tenant }"></ng-container>
        }

        <ng-template #tenantRowTemplate let-tenant="tenant">
            <div
                #tenantRow
                tabindex="0"
                class="tenant-switcher-row"
                [class.selected-tenant]="tenant.tenantId === tenantCode"
                [class.active-tenant]="tenant.activeFlag"
                (click)="selectTenant(tenant)"
                title="{{
                    tenant.tenantId === tenantCode ? 'Current tenant' : 'Switch to this tenant (' + tenant.name + ')'
                }}"
                (keydown)="onTenantRowKeydown($event, tenant)"
            >
                <span class="tenant-switcher-row-id">
                    <span
                        class="cdp-tenant-code-badge"
                        [innerHTML]="tenant.tenantId | highlight: tenantSearch.value"
                    ></span>
                </span>
                <span class="tenant-switcher-row-name">
                    <span
                        class="icon-left {{ tenant.activeFlag ? 'icon-status-success' : 'icon-status-cancelled' }}"
                    ></span>
                    <span
                        class="tenant-switcher-row-name-inner"
                        [innerHTML]="tenant.name | highlight: tenantSearch.value"
                    ></span>
                </span>
                <span class="tenant-switcher-row-location">{{ tenant.locationAbbrev }}</span>
                <span
                    hcTooltip="{{ tenant.isFavorite ? 'Remove from favorites' : 'Add to favorites' }}"
                    title=""
                    class="cdp-fav-ico icon-star{{ tenant?.isFavorite ? ' favorited' : '-o' }}"
                    (click)="toggleFavTenant(tenant, $event)"
                ></span>
            </div>
        </ng-template>
    </div>
    <div class="tenant-switcher-footer" *ngIf="isGlobalAdmin">
        <a href="/global-admin/tenants" class="tenant-switcher-footer-link">
            <span>Manage tenants</span>
            <span class="icon-right icon-chev-right"></span>
        </a>
    </div>
</div>
